import { VERBS } from '../constants';

export function optimizelyTrack(configFn) {
  return (event) => {
    const { env, userId, track, transforms } = configFn();
    if (VERBS.includes(event.verb)) {
      const tags = {};
      if (event.details && event.details.revenueInCents) {
        tags.revenue = event.details.revenueInCents;
      }
      track(env, userId, event, tags, transforms);
    }
  };
}
